/**
 *  @class
 *  @function SocialShare
 */
if (!customElements.get('social-share')) {
  class SocialShare extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.container = this;
      this.links = this.querySelectorAll('.social');

      this.setupEventListeners();
    }

    setupEventListeners() {
      this.links.forEach((link) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();

          // N'ouvre que des liens de partage http(s)
          let shareUrl;
          try {
            shareUrl = new URL(link.href);
          } catch (e) {
            return;
          }
          if (shareUrl.protocol !== 'https:' && shareUrl.protocol !== 'http:') return;

          let left = (screen.width / 2) - (640 / 2),
            top = (screen.height / 2) - (440 / 2) - 100;
          window.open(shareUrl.href, 'mywin', 'left=' + left + ',top=' + top + ',width=640,height=440,toolbar=0');
        });
      });
    }
  }
  customElements.define('social-share', SocialShare);
}
